import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import { Tab, TabItem } from "../../Reusablecomponents/Tab";
import UITable, { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import UIModal from "../../Reusablecomponents/UIModal";
import EditIcon from "../../assets/images/edit-icon.svg";
import DeleteIcon from "../../assets/images/delete-icon.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons/index";
import { Tooltip, Col, Collapse, Row, Spin, Switch } from "antd";
import { Select, Space, Form, Input, message } from "antd";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import RoleAction from "./RoleAction";
import AssignedRole from "./AssignedRole";
import axios from "axios";

const { Panel } = Collapse;
const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 350px !important;
    outline: none;
    border-color: #f1f1f1;
    border-radius: 100px !important; // Add border radius
  }
  // .ant-select-outlined:hover{
  // border-color: #f1f1f1 !important;
  // }
  // .ant-select-focused{
  // border-color: #f1f1f1 !important;
  // }
  // :where(.css-dev-only-do-not-override-cdzvx5).ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
  // border-color: #f1f1f1 !important;

  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    background-color: white;
  }
`;

const Wrapperbox = styled.div`
  /* *{
  background-color: white;
} */

  .ant-tabs-tab {
    background-color: white;
    border-radius: 22px;
    padding: 10px 16px;
    margin-right: 10px;
    transition: background-color 0.3s ease;
  }

  .ant-tabs-tab:nth-of-type(1).ant-tabs-tab-active {
    background-color: rgb(241, 241, 241) !important;
    color: green !important;
  }

  .ant-tabs-tab:nth-of-type(2).ant-tabs-tab-active {
    background-color: rgb(241, 241, 241) !important;
    color: green !important;
  }

  .ant-tabs-tab:nth-of-type(3).ant-tabs-tab-active {
    background-color: rgb(241, 241, 241) !important;
    color: green !important;
  }
  .rollActionName_container {
    padding: 8px 5px 8px 5px;
  }
  .rollActionName_container_one {
    background-color: rgb(235, 247, 235);
  }

  @media (max-width: 480px) {
    .selectrole_container_three {
      flex-direction: column;
      gap: 20px;
    }
    .rollActionName_containerfor_switch {
      align-self: flex-end;
      gap: 20px;
    }
    .Choose_all {
      margin: 0px 15px 0px 0px;
    }
    .ant-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 12px;
    }
    .ant-tabs-nav-list {
      flex-direction: column;
      gap: 10px;
    }
  }
`;

//Role Action Tab selection option cmd
const RoleChange = (value) => {
  console.log(`selected ${value}`);
};
const RoleSelection = () => {
  return (
    <Space wrap>
      <StyledSelect>
        <Select
          defaultValue="Cargo"
          style={{ width: "500px" }}
          onChange={RoleChange}
          options={[
            {
              value: "Admin",
              label: "Admin",
            },
            {
              value: "Cargo",
              label: "Cargo",
            },
            {
              value: "disabled",
              label: "Disabled",
              disabled: true,
            },
          ]}
        />
      </StyledSelect>
    </Space>
  );
};

const RoleManagement = () => {
  const roleList = useSelector((state) => state?.authTracking?.roleList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const createAllowed = useMemo(
    () => hasPermission("ROLE", "C"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("ROLE", "U"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("ROLE", "D"),
    [reduxPermissions],
  );
  const RolesColumn = [
    {
      title: "Role Name",
      dataIndex: "ROLENAME",
      key: "ROLENAME",
    },
    {
      title: "",
      width: 50,
      key: "actions",
      render: (_, record) => (
        <Tooltip title={!updateAllowed ? "No permission" : ""}>
          <img
            src={EditIcon}
            style={{
              color: "#E4A400",
              width: "18px",
              cursor: updateAllowed ? "pointer" : "not-allowed",
            }}
            onClick={(e) => {
              if (!updateAllowed) return;
              setIsEditRole(true);
              e.stopPropagation();
              setFormData({
                roleid: record?.ROLEID,
                rolename: record?.ROLENAME,
                MCID: record?.MCID,
              });
              form.setFieldsValue({
                rolename: record?.ROLENAME,
              });
              setIsModalOpen(true);
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: "",
      width: 50,
      key: "actions",
      render: (_, record) => (
        <Tooltip title={!deleteAllowed ? "No permission" : ""}>
          <img
            src={DeleteIcon}
            style={{
              color: "red",
              width: "18px",
              cursor: deleteAllowed ? "pointer" : "not-allowed",
            }}
            onClick={(e) => {
              if (!deleteAllowed) return;
              e.stopPropagation();
              openDeleteModal(record);
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: "",
      width: 200,
      key: "plainspace",
    },
  ];
  const RoleActionData = [
    {
      Key: 1,
      RollActionName: "Action Log",
    },
    {
      Key: 2,
      RollActionName: "Custome Dashboard",
    },
    {
      Key: 3,
      RollActionName: "Operations",
    },
    {
      Key: 4,
      RollActionName: "Action Log",
    },
    {
      Key: 5,
      RollActionName: "Custome Dashboard",
    },
    {
      Key: 6,
      RollActionName: "Operations",
    },
    {
      Key: 7,
      RollActionName: "Action Log",
    },
  ];
  const RoleAssignmentData = [
    {
      key: "1",
      UserId: "Admin001",
      UserName: "Admin",
      Email: "Admin@gmail.com",
      RoleAssigned: "2",
    },
    {
      key: "2",
      UserId: "Admin002",
      UserName: "Admin",
      Email: "Admin@gmail.com",
      RoleAssigned: "1",
    },
    {
      key: "3",
      UserId: "Admin002",
      UserName: "Admin",
      Email: "Admin@gmail.com",
      RoleAssigned: "1",
    },
  ];

  const RoleAssignmentColumns = [
    {
      title: "User Id",
      dataIndex: "USERID",
      key: "USERID",
    },
    {
      title: "User Name",
      dataIndex: "FULLNM",
      key: "FULLNM",
    },
    {
      title: "Email",
      dataIndex: "EMAIL",
      key: "EMAIL",
    },
    // {
    //   title: "Role Assigned",
    //   dataIndex: "RoleAssigned",
    //   key: "RoleAssigned",
    // },
  ];

  //Role Action tab page toogle button code
  const [allRoleSelect, setAllRoleSelect] = useState(false);
  // State to manage individual role action toggles
  const [roleStates, setRoleStates] = useState(RoleActionData.map(() => false));
  // Handle "Select All" toggle
  const handleRole = (checked) => {
    // const newState = !allRoleSelect;
    setAllRoleSelect(checked);
    setRoleStates(RoleActionData.map(() => checked)); // Update all roles to the new state
  };

  // Handle individual role action toggle
  const handleIndividualRoleChange = (index) => {
    const newRoleStates = [...roleStates];
    newRoleStates[index] = !newRoleStates[index];
    setRoleStates(newRoleStates);

    // Update "Select All" state if all roles are selected/deselected
    if (newRoleStates.every((state) => state)) {
      setAllRoleSelect(true);
    } else if (newRoleStates.every((state) => !state)) {
      setAllRoleSelect(false);
    } else {
      setAllRoleSelect(false);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [rolesData, setRolesData] = useState([]);
  const [roleActionData, setRoleActionData] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const [isEditRole, setIsEditRole] = useState(false);
  const [roleAssignedData, setRoleAssignedData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    rolename: "",
  });
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [roleAssignedTotal, setRoleAssignedTotal] = useState(0);
  const [currentAssignedPage, setCurrentroleAssignedPage] = useState(1);
  const [roleAssignedPageSize, setRoleAssignedPageSize] = useState(10);
  const [dataforroleassign, setDataforroleassign] = useState([]);
  const [roleAssignId, setRoleAssignId] = useState(null);
  const [assignedRoleLoading, setAssignedRoleLoading] = useState(false);
  console.log("roleAssignId`", roleAssignId);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);

  const openDeleteModal = (record) => {
    setRecordToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setRecordToDelete(null);
  };
  const handleRoleAssignedPageSizeChange = (value) => {
    setCurrentroleAssignedPage(1);
    setRoleAssignedPageSize(value);
  };
  const handleRoleAssignPageChange = (page, pageSize) => {
    setCurrentroleAssignedPage(page);
    setRoleAssignedPageSize(pageSize);
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchAllRoleAction = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "role/roleAction", {
        MCID: userInfo.MCID,
        ROLEId: 185,
      });
      setPermissions(data);
    } catch (error) {
      console.error("[fetchAllRoleAction] error:", error);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => setIsModalOpen(true);

  const handleCreateRole = async (values) => {
    const payload = {
      UID: userInfo?.UID,
      ROLENAME: values?.rolename,
      MCID: userInfo?.MCID,
      ACTION: "INSERT",
    };
    const editpayload = {
      UID: userInfo?.UID,
      ACTION: "UPDATE",
      ROLEID: formData?.roleid,
      ROLENAME: values?.rolename,
      MCID: formData?.MCID,
    };
    try {
      setLoading(true);
      const {
        data,
        message: Message,
        ResponseCode,
      } = await CALL_API(
        "POST",
        `role/create_role`,
        isEditRole ? editpayload : payload,
      );
      fetchRolesData();
      handleCancel();
      setLoading(false);
      if (ResponseCode === 200) {
        message.success(
          isEditRole
            ? "Role Updated Successfully"
            : "Role Created Successfully",
        );
      } else {
        message.warning(Message);
      }
    } catch (error) {
      console.error("[handleCreateRole] error -->", error);
    }
  };

  const handleDeleteRole = async () => {
    if (!recordToDelete) return;

    const payload = {
      UID: userInfo?.UID,
      ROLEID: recordToDelete?.ROLEID,
      // ROLENAME: recordToDelete?.ROLENAME,
      // MCID: recordToDelete?.MCID,
      // ACTION: "DELETE",
    };
    try {
      setLoading(true);
      const { data } = await CALL_API("Delete", `/role/Deleterole`, payload);

      fetchRolesData();
      if (data?.insertedData?.noOfUsers === 0) {
        message.success("Role deleted successfully");
      } else {
        message.error(
          data?.message ||
            "Role cannot be deleted because it is assigned to users",
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("[handleCreateRole] error -->", error);
    }
  };

  const fetchRolesData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `roles/getAllRoles?limit=${pageSize}&page=${currentPage}`,
        {},
      );
      setRolesData(data?.data);
      setTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const fetchRoleActionData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `roles/getAllRolesActions?limit=10&page=1`,
        {},
      );
      setRoleActionData(data?.data);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const fetchRoleAssignedData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `roles/getAllRolesAssigned?limit=${roleAssignedPageSize}&page=${currentAssignedPage}&mcid=${userInfo?.MCID}&roleId=301`,
        {},
      );
      setRoleAssignedData(data?.data);
      setLoading(false);
      setRoleAssignedTotal(data?.totalRecords);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({
      role: "",
    });
    form.resetFields();
    console.log("isModalOpen-->", isModalOpen);
    console.log("close button clicked", isModalOpen);
  };

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form Data:", values);
        message.success("Role created successfully!");
        form.resetFields();
        setIsModalOpen(false); // Close modal after creation
      })
      .catch((errorInfo) => console.error("Validation Failed:", errorInfo));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData({
      rolename: "",
    });
    form.resetFields();
    form.setFieldsValue({
      rolename: "",
    });
    setIsEditRole(false);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const showEditModal = () => {
    setIsEditModalOpen(true);
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };
  const [isUpdated, setIsUpdated] = useState(false);

  const editModuleupdate = () => {
    setIsUpdated(true);
    message.success("Role updated successfully!");
  };

  const getRolebyUser = async () => {
    setAssignedRoleLoading(true);
    const { data } = await CALL_API(
      "GET",
      `role/getRolebyUserId?userId=${roleAssignId}`,
      {},
    );
    setDataforroleassign(data);
    setAssignedRoleLoading(false);
  };

  useEffect(() => {
    if (!roleAssignId) return;

    getRolebyUser();
  }, [roleAssignId]);

  console.log("dataforroleassign---->", dataforroleassign);
  console.log("dataforroleassign---->", typeof dataforroleassign);
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  const handleTitleChange = (e) => {
    const { value } = e.target;
    if (/[^a-zA-Z\s]/.test(value)) {
      setError("Only alphabets are allowed. No numbers or special characters.");
    } else {
      setError("");
    }
    if (value.length <= 30) {
      setTitle(value);
    }
  };
  const tabItems = [
    // Roles Tab
    TabItem({
      label: "Roles",
      content: (
        <>
          <div className="d-flex justify-content-between align-items-center">
            <label>{total} Roles</label>
            <Tooltip title={!createAllowed ? "No permission" : ""}>
              <ButtonFilled disabled={!createAllowed} onClick={showModal}>
                {" "}
                + Create
              </ButtonFilled>
            </Tooltip>
          </div>
          <div>
            <Spin spinning={loading}>
              <UITable
                dataSource={rolesData}
                columns={RolesColumn}
                pagination={false}
              />
              <ReusablePagination
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
                currentPage={currentPage}
                total={total}
                handlePageChange={handlePageChange}
              />
            </Spin>
          </div>
        </>
      ),
    }),
    // Role Action Tab
    TabItem({
      label: "Roles Action",
      content: <RoleAction />,
    }),

    //Role Assignment tab
    TabItem({
      label: "Roles Assignment",
      content: (
        <>
          <Row gutter={16}>
            <Col span={12}>
              <div className="mt-3">
                <label className="mb-0">{roleAssignedTotal} Users</label>
              </div>
              <div>
                {roleAssignedData.length > 0 && (
                  <StyledTable
                    className="mt-3"
                    dataSource={roleAssignedData}
                    columns={RoleAssignmentColumns}
                    pagination={false}
                    style={{
                      cursor: "default",
                    }}
                    onRow={(record, rowIndex) => {
                      console.log("record", record);
                      return {
                        onClick: (event) => {
                          setRoleAssignId(record?.UID);
                        }, // click row
                      };
                    }}
                  />
                )}

                <ReusablePagination
                  pageSize={roleAssignedPageSize}
                  handlePageSizeChange={handleRoleAssignedPageSizeChange}
                  currentPage={currentAssignedPage}
                  total={roleAssignedTotal}
                  handlePageChange={handleRoleAssignPageChange}
                />
              </div>
            </Col>
            <Col span={12}>
              <AssignedRole
                dataforroleassign={dataforroleassign}
                roleAssignId={roleAssignId}
                getRolebyUser={getRolebyUser}
                assignedRoleLoading={assignedRoleLoading}
              />
            </Col>
          </Row>
        </>
      ),
    }),
  ];
  const onChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    fetchAllRoleAction();
    fetchRoleActionData();
  }, []);

  useEffect(() => {
    fetchRoleAssignedData();
  }, [currentAssignedPage, roleAssignedPageSize]);

  useEffect(() => {
    fetchRolesData();
  }, [currentPage, pageSize]);
  //Role editmoduel

  return (
    <div>
      <Wrapperbox>
        <Tab defaultActiveKey="1" items={tabItems} onChange={onChange} />
      </Wrapperbox>
      {/* <UIModal open={isModalOpen} onClose={handleCloseModal}/> */}
      <UIModal
        header={isEditRole ? "Updating Role" : "Creating Role"}
        open={isModalOpen}
        onClose={handleCancel}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent onClick={handleCancel}>Cancel</Buttontransparent>
            <ButtonFilled loading={loading} onClick={() => form.submit()}>
              {isEditRole ? "Update" : "Create"}
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="p-3">
          <Form
            form={form}
            labelCol={{ span: 12 }} // Label width (6 out of 24)
            wrapperCol={{ span: 24 }} // Input width (18 out of 24)
            layout="vertical" // Horizontal layout
            style={{ paddingBottom: "150px" }}
            onFinish={handleCreateRole}
          >
            <Form.Item
              label="Title of the Role"
              name="rolename"
              rules={[
                { required: true, message: "Ttile of the Role is required" },
                {
                  pattern: /^[a-zA-Z\s]+$/,
                  message:
                    "Only alphabetic characters, numbers, and spaces are allowed",
                },
              ]}
            >
              <Input
                placeholder=""
                className="rounded-pill"
                maxLength={30}
                onChange={handleTitleChange}
              />
            </Form.Item>
          </Form>
        </div>
      </UIModal>

      <UIModal
        header="Modifying Role"
        open={isEditModalOpen}
        onClose={closeEditModal}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent onClick={closeEditModal}>
              Cancel
            </Buttontransparent>
            <ButtonFilled onClick={editModuleupdate}>Update</ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="p-3">
          <Form
            form={form}
            labelCol={{ span: 12 }} // Label width (6 out of 24)
            wrapperCol={{ span: 24 }} // Input width (18 out of 24)
            layout="vertical" // Horizontal layout
            style={{ paddingBottom: "150px" }}
          >
            <Form.Item name="rolename" label="Title of the Role">
              <Input placeholder="Admin" className="rounded-pill" />
            </Form.Item>
          </Form>
        </div>
      </UIModal>
      <UIModal
        open={isDeleteModalOpen}
        onClose={closeDeleteModal}
        size="400px"
        closeButton={false}
      >
        <h3>Are You Sure?</h3>
        <p>You will not be able to recover</p>
        <Buttontransparent onClick={closeDeleteModal} style={{ width: "60px" }}>
          No
        </Buttontransparent>

        <ButtonFilled
          loading={loading}
          onClick={handleDeleteRole}
          disabled={loading}
          style={{ width: "60px", position: "relative" }}
        >
          {loading ? <span style={{ position: "absolute" }}>Yes</span> : "Yes"}
        </ButtonFilled>
      </UIModal>
    </div>
  );
};
export default RoleManagement;
